module.exports = __webpack_public_path__ + "d7c679871a2452382c6b7553692b44e2.jpg";